import React from "react";

export const Alert = props => {
  return <div className="alert-block">{props.message}</div>;
};



// WEBPACK FOOTER //
// ./src/modules/BookingPortal/components/Shared/Alert.js